import { formatUTCDate } from 'core';
import { selectBasketValidDate } from 'store/basket/basketSlice';
import { useAppSelector } from 'store';

import { BcAlert } from '@britishcouncil/react-solas';

export const ExamsValidDateMsg = () => {
  const validDate = useAppSelector(selectBasketValidDate);

  if (!validDate.priceValidTo) return null;

  return (
    <BcAlert type="note" title="Please note">
      {validDate.isLastSessionStage ? (
        <p>
          This fee is valid up to and including <strong>{formatUTCDate(validDate.priceValidTo)} (GMT/BST)</strong> after which the
          registration window will be closed.
        </p>
      ) : (
        <p>
          This fee is valid up to and including <strong>{formatUTCDate(validDate.priceValidTo)} (GMT/BST)</strong> after which
          additional/late fees will be charged.
        </p>
      )}
    </BcAlert>
  );
};
